import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';
export const ADD_TO_BOOKMARKS_CAP = defineCapability({
  name: 'ADD_TO_BOOKMARKS_CAP',
  args: {
    path: args.string(),
    id: args.string()
  }
});